/**
 * Firestore `orders` documents use mixed time fields: `orderDate` (Timestamp),
 * optional legacy `createdAt`, and `date_added` (ISO string). There is no single
 * guaranteed `createdAt` on older imports. Do not use `date_updated` as “order placed” time.
 */

/**
 * @param {unknown} v
 * @returns {number|null}
 */
function toMillisSafe(v) {
    if (v == null) return null;
    try {
        if (typeof v === 'number' && !Number.isNaN(v)) return v;
        if (v && typeof v.toMillis === 'function') return v.toMillis();
        if (v && v.seconds != null) return Number(v.seconds) * 1000;
        if (v instanceof Date) return v.getTime();
        const p = Date.parse(String(v));
        return Number.isNaN(p) ? null : p;
    } catch {
        return null;
    }
}

/**
 * Best-effort “when was this order placed?” for eligibility, sorting, and reports.
 * Order: `orderDate` → `createdAt` → `date_added`.
 *
 * @param {Record<string, unknown>|null|undefined} data
 * @returns {number|null} ms since epoch
 */
export function getOrderDocumentTimeMs(data) {
    if (!data || typeof data !== 'object') return null;
    const a = toMillisSafe(data.orderDate);
    if (a != null) return a;
    const b = toMillisSafe(data.createdAt);
    if (b != null) return b;
    return toMillisSafe(data.date_added);
}
